import { render } from "./NotiScreen.vue?vue&type=template&id=1067ac74&scoped=true"
import script from "./NotiScreen.vue?vue&type=script&lang=js"
export * from "./NotiScreen.vue?vue&type=script&lang=js"

import "./NotiScreen.vue?vue&type=style&index=0&id=1067ac74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1067ac74"]])

export default __exports__